import { useEffect, useState } from "react";
import { Button, Form, Modal, Spinner, Table } from "react-bootstrap";
import contact from "../api/contact";

const ContactMessages = () => {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Reply modal states
  const [showModal, setShowModal] = useState(false);
  const [selectedMessage, setSelectedMessage] = useState(null);
  const [replyText, setReplyText] = useState("");
  const [sending, setSending] = useState(false);

  useEffect(() => {
    const fetchMessages = async () => {
      try {
        const response = await contact.getContactMessages();
        setMessages(response.data);
      } catch (err) {
        setError(err.message || "Failed to load messages");
      } finally {
        setLoading(false);
      }
    };

    fetchMessages();
  }, []);

  // Open reply modal
  const handleReply = (message) => {
    setSelectedMessage(message);
    setReplyText("");
    setShowModal(true);
  };

  // Send reply (email-like)
  const handleSendReply = () => {
    if (!replyText.trim()) {
      alert("Reply message cannot be empty");
      return;
    }

    setSending(true);

    const mailtoLink = `mailto:${selectedMessage.email}?subject=${encodeURIComponent(
      "Re: " + selectedMessage.subject
    )}&body=${encodeURIComponent(replyText)}`;

    window.location.href = mailtoLink;

    setTimeout(() => {
      setSending(false);
      setShowModal(false);
    }, 800);
  };

  return (
    <div>
      <h1>Contact Messages</h1>

      {loading && <p>Loading messages...</p>}
      {error && <p className="text-danger">Error: {error}</p>}

      {!loading && !error && (
        <Table striped bordered hover className="mt-3">
          <thead>
            <tr>
              <th>ID</th>
              <th>Name</th>
              <th>Email</th>
              <th>Subject</th>
              <th>Message</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {messages.map((msg) => (
              <tr key={msg.id}>
                <td>{msg.id}</td>
                <td>
                  {msg.firstName} {msg.lastName}
                </td>
                <td>{msg.email}</td>
                <td>{msg.subject}</td>
                <td>{msg.message}</td>
                <td>
                  <Button
                    variant="outline-primary"
                    onClick={() => handleReply(msg)}
                  >
                    Reply
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}

      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Reply to Message</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {selectedMessage && (
            <>
              <p>
                <strong>To:</strong> {selectedMessage.email}
              </p>
              <p>
                <strong>Subject:</strong> Re: {selectedMessage.subject}
              </p>

              <Form.Group className="mt-3">
                <Form.Label>Message</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={5}
                  placeholder="Type your reply here..."
                  value={replyText}
                  onChange={(e) => setReplyText(e.target.value)}
                />
              </Form.Group>
            </>
          )}
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Cancel
          </Button>

          <Button
            variant="primary"
            onClick={handleSendReply}
            disabled={sending}
          >
            {sending ? (
              <>
                Sending <Spinner animation="border" size="sm" className="ms-2" />
              </>
            ) : (
              "Send Reply"
            )}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ContactMessages;
